import { defineMessages } from 'react-intl';
var messages = defineMessages({
  correctedAnswersText: {
    id: "QuizResult.correctedAnswersText",
    defaultMessage: [{
      "type": 1,
      "value": "correctNum"
    }, {
      "type": 0,
      "value": " of "
    }, {
      "type": 1,
      "value": "totalNum"
    }, {
      "type": 0,
      "value": " questions answered correctly"
    }]
  },
  reachedPointsText: {
    id: "QuizResult.reachedPointsText",
    defaultMessage: [{
      "type": 0,
      "value": "You have reached "
    }, {
      "type": 1,
      "value": "userTotalPoints"
    }, {
      "type": 0,
      "value": " of "
    }, {
      "type": 1,
      "value": "quizPoints"
    }, {
      "type": 0,
      "value": " point(s), ("
    }, {
      "type": 1,
      "value": "pass"
    }, {
      "type": 0,
      "value": "%)"
    }]
  },
  studentPassedText: {
    id: "QuizResult.studentPassedText",
    defaultMessage: [{
      "type": 0,
      "value": "(student passed)"
    }]
  },
  studentDidNotPassText: {
    id: "QuizResult.studentDidNotPassText",
    defaultMessage: [{
      "type": 0,
      "value": "(student did not pass)"
    }]
  },
  backToTitle: {
    id: "QuizResult.backToTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Back to "
    }, {
      "type": 1,
      "value": "name"
    }]
  },
  resultsTitle: {
    id: "QuizResult.resultsTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Results"
    }]
  },
  userTimeTitle: {
    id: "QuizResult.userTimeTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Your time:"
    }]
  },
  restartQuizBtnLabel: {
    id: "QuizResult.restartQuizBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Restart quiz"
    }]
  },
  restartExamBtnLabel: {
    id: "QuizResult.restartExamBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Restart exam"
    }]
  },
  viewQuizReportBtnLabel: {
    id: "QuizResult.viewQuizReportBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "View Quiz Report"
    }]
  },
  viewExamReportBtnLabel: {
    id: "QuizResult.viewExamReportBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "View Exam Report"
    }]
  },
  goToResultBtnLabel: {
    id: "QuizResult.goToResultBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Go to result"
    }]
  },
  nextBtnTooltip: {
    id: "LessonDetails.nextBtnTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Next: "
    }, {
      "type": 1,
      "value": "name"
    }]
  },
  dateLabel: {
    id: "QuizResult.dateLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Date:"
    }]
  },
  quizTimeLabel: {
    id: "QuizResult.quizTimeLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Quiz time:"
    }]
  },
  examTimeLabel: {
    id: "QuizResult.examTimeLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Exam time:"
    }]
  },
  pointsInTotalLabel: {
    id: "QuizResult.pointsInTotalLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Points in total"
    }]
  },
  passRequirermentLabel: {
    id: "QuizResult.passRequirermentLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Pass requirement "
    }, {
      "type": 1,
      "value": "perc"
    }, {
      "type": 0,
      "value": "%"
    }]
  },
  numberOfAttemptsLabel: {
    id: "QuizResult.numberOfAttemptsLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Number of attempts"
    }]
  },
  progressLabel: {
    id: "QuizResult.progressLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Progress"
    }]
  },
  studentLabel: {
    id: "QuizResult.studentLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Student"
    }]
  },
  meLabel: {
    id: "QuizResult.meLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Me"
    }]
  },
  answerLabel: {
    id: "QuizResult.answerLabel",
    defaultMessage: [{
      "type": 0,
      "value": "answer"
    }]
  },
  myGroupLabel: {
    id: "QuizResult.myGroupLabel",
    defaultMessage: [{
      "type": 0,
      "value": "My group"
    }]
  },
  questionsLabel: {
    id: "QuizResult.questionsLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Questions"
    }]
  },
  correctLabel: {
    id: "QuizResult.correctLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Correct"
    }]
  },
  reflectionNoteLabel: {
    id: "QuizResult.reflectionNoteLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Question note:"
    }]
  },
  pointsLabel: {
    id: "QuizResult.pointsLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Points"
    }]
  },
  completedItemsInSection: {
    id: "QuizResult.completedItemsInSection",
    defaultMessage: [{
      "type": 0,
      "value": "Completed "
    }, {
      "type": 1,
      "value": "completedLessons"
    }, {
      "type": 0,
      "value": " lesson(s) and "
    }, {
      "type": 1,
      "value": "completedQuizzes"
    }, {
      "type": 0,
      "value": " quiz(zes) of "
    }, {
      "type": 1,
      "value": "totalLessons"
    }, {
      "type": 0,
      "value": " total lesson(s) and "
    }, {
      "type": 1,
      "value": "totalQuizzes"
    }, {
      "type": 0,
      "value": " total quiz(zes) in the section"
    }]
  },
  showCertificateBtnLabel: {
    id: "LessonDetails.showCertificateBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Show course certificate"
    }]
  },
  showExamCertificateBtnLabel: {
    id: "QuizResult.showExamCertificateBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Show exam certificate"
    }]
  },
  tasksLabel: {
    id: "LessonDetails.tasksLabel",
    defaultMessage: [{
      "type": 0,
      "value": "tasks"
    }]
  },
  taskResultsLabel: {
    id: "LessonDetails.taskResultsLabel",
    defaultMessage: [{
      "type": 0,
      "value": "task results"
    }]
  },
  trueValue: {
    id: "QuizResult.trueValue",
    defaultMessage: [{
      "type": 0,
      "value": "True"
    }]
  },
  falseValue: {
    id: "QuizResult.falseValue",
    defaultMessage: [{
      "type": 0,
      "value": "False"
    }]
  },
  examLabel: {
    id: "QuizResult.examLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Exam"
    }]
  },
  resultsLabel: {
    id: "QuizResult.resultsLabel",
    defaultMessage: [{
      "type": 0,
      "value": "results"
    }]
  },
  issueCertificate: {
    id: "QuizResult.issueCertificate",
    defaultMessage: [{
      "type": 0,
      "value": "Issue certificate"
    }]
  },
  alterToMaxScoreAndAssignCertificate: {
    id: "QuizResult.alterToMaxScoreAndAssignCertificate",
    defaultMessage: [{
      "type": 0,
      "value": "Alter to max score, passed and assign certificate"
    }]
  },
  alterToNotPassedAndRevokeCertificate: {
    id: "QuizResult.alterToNotPassedAndRevokeCertificate",
    defaultMessage: [{
      "type": 0,
      "value": "Alter to not passed and revoke certificate"
    }]
  },
  backToTasks: {
    id: "QuizResult.backToTasks",
    defaultMessage: [{
      "type": 0,
      "value": "Back to tasks"
    }]
  },
  attemptsNumber: {
    id: "ExamTaskResults.attemptsNumber",
    defaultMessage: [{
      "type": 0,
      "value": "Number of new retries"
    }]
  },
  unlockExamLabel: {
    id: "ExamTaskResults.unlockExamLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Unlock"
    }]
  },
  availableLabel: {
    id: "ExamTaskResults.availableLabel",
    defaultMessage: [{
      "type": 0,
      "value": "open"
    }]
  },
  statusLabel: {
    id: "ExamTaskResults.statusLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Status"
    }]
  },
  quizSessionIsNotEnded: {
    id: "ExamTaskResults.quizSessionIsNotEnded",
    defaultMessage: [{
      "type": 0,
      "value": "Exam session is still going, answers will become available once it's finished by user or automatically after "
    }, {
      "type": 1,
      "value": "timeEnd"
    }]
  },
  notStartedLabel: {
    id: "ExamTaskResults.notStartedLabel",
    defaultMessage: [{
      "type": 0,
      "value": "not started"
    }]
  },
  finished: {
    id: "ExamTaskResults.finished",
    defaultMessage: [{
      "type": 0,
      "value": "finished"
    }]
  },
  nextBtnLabel: {
    id: "LessonDetails.nextBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Next"
    }]
  },
  mathQuestionNotAllowedDecimalsHint: {
    id: "QuizResult.mathQuestionNotAllowedDecimalsHint",
    defaultMessage: [{
      "type": 0,
      "value": "(Decimals in the answer are not allowed)"
    }]
  },
  mathQuestionAllowedDecimalsHint: {
    id: "QuizResult.mathQuestionAllowedDecimalsHint",
    defaultMessage: [{
      "type": 0,
      "value": "(Required "
    }, {
      "type": 1,
      "value": "allowedDecimals"
    }, {
      "type": 0,
      "value": " "
    }, {
      "type": 6,
      "value": "allowedDecimals",
      "options": {
        "one": {
          "value": [{
            "type": 0,
            "value": "sign"
          }]
        },
        "other": {
          "value": [{
            "type": 0,
            "value": "signs"
          }]
        }
      },
      "offset": 0,
      "pluralType": "cardinal"
    }, {
      "type": 0,
      "value": " after the comma)"
    }]
  }
});
export default messages;